import { Link } from "react-router-dom";

import "./AppButton.css";

const AppButton = (props: any) => {
  // não renderiza nada caso possua a propriedade hidden=true
  if (props.hidden) return <></>;

  return props.route ? (
    <Link
      to={props.route}
      className={`${props.outlined ? "outlined" : "normal"}`}
      id={props.id}
      onClick={props.click}
    >
      {props.content}
    </Link>
  ) : (
    <button
      className={`${props.outlined ? "outlined" : "normal"}`}
      id={props.id}
      onClick={props.click}
      disabled={props.disabled}
      style={{ flexDirection: props.labelDirection ? "column" : "row" }}
    >
      {props.content}
    </button>
  );
};

export default AppButton;
